<template>
  <div class="bg-white pb-12">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Request
      </h2>
    </div>
    <div class="flex p-8 menucontrol-scroll fixed-top">
      <div class="w-full">
        <div class="grid grid-cols-2 gap-8 w-full">
          <div
            class="flex items-start border rounded-10px cursor-pointer p-4"
            v-for="(item, index) in addOns"
            :key="'item-' + index"
          >
            <div class="flex gap-6 w-10/12">
              <img
                v-if="item.addOnId"
                :src="showImage(item.addOnId.images)"
                class="object-contain wh-75px rounded-10px p-3 bg-cas"
                alt="banh"
              />

              <div class="w-full">
                <h3
                  class="col-4f text-xl mb-0 font-semibold"
                  v-if="item.addOnId"
                >
                  {{ item.addOnId.name }}
                </h3>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                  v-if="item.addOnId"
                >
                  {{ item.addOnId.quantity
                  }}<span class="pl-1">{{ item.addOnId.unit }}</span>
                </p>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                  v-if="item.hasOwnProperty('purchased_on')"
                >
                  {{ item.purchased_on }}
                </p>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                  v-else
                >
                  --No Purchased Date--
                </p>

                <!-- <p
                @click="handleClick"
                class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
              >
                View Details
              </p> -->
              </div>
            </div>
            <!-- <div class="w-2/12 flex justify-end cursor-pointer">
            <el-input-number
              size="small"
              v-model="item.booster"
              @change="handleChange"
              :min="0"
              :max="10"
            ></el-input-number>
          </div> -->

            <el-tag
              type="warning"
              class="rounded-full"
              v-if="item.cloudStatus == false"
            >
              Pending</el-tag
            >
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      @current-change="
        (value) => {
          currentPage = value;
          myAddOnsRequest();
        }
      "
      layout="prev,pager,next"
      :per-size="10"
      :total="pageCount"
    ></el-pagination>
  </div>
</template>
<script>
import addOnsMaster from "@/Apicall/masters/addons.js";
import Plans2 from "@/views/adminPanel/pages/ecommerce/components/Plans2";
import { mapState } from "vuex";
export default {
  components: {
    Plans2,
  },
  data() {
    return {
      addOns: [],
      num: 1,
      pageCount: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.myAddOnsRequest();
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["addOnType"]),
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "Add-ons-AddonsDetailSummary" });
    },
    handleChange(value) {
      console.log(value);
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return !!value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },

    async myAddOnsRequest() {
      let offset = 0;
      let payload = {
        projectName: this.selectedProject.projectName,
        paginated: true,
        offset: 10 * this.currentPage - 10,
        cloudStatus: false,
        addOnType: this.addOnType,
      };
      const { data } = await addOnsMaster.myAddOnsRequest(payload);
      console.log(data, "ADDONS");
      this.addOns = data.data.data;
      // this.addOns = data.data.data.filter(
      //   (x) => x.addOnId.addOnType == this.addOnType
      // );
      // console.log(this.addOns, "ADDONS");
      this.pageCount = data.data.count;
      // this.pageCount = this.addOns.length;
    },
  },
};
</script>
